import { View } from "react-native";
import { Info } from "lucide-react-native";
import { colors } from "@louise/moon-ui/theme/tokens";
import { MoonText } from "@louise/moon-ui/primitives/MoonText";

type SampleBannerProps = {
  message: string;
};

export default function SampleBanner({ message }: SampleBannerProps) {
  return (
    <View className="border-l-moon-warm bg-moon-warm/10 flex-row items-start gap-2 rounded-xl border-l-[3px] px-4 py-3">
      <Info size={18} color={colors.warm} className="mt-px" />
      <MoonText className="flex-1">{message}</MoonText>
    </View>
  );
}
